import React, { useState, useEffect } from 'react'
import { withRouter } from 'react-router-dom'
import { Card, Tag, Avatar, Result, Form, Button, Steps, Input, message, Divider } from 'antd'
import {
    MailOutlined,
    SolutionOutlined,
    LoadingOutlined,
    Loading3QuartersOutlined,
    SmileOutlined,
    CloseCircleOutlined
} from '@ant-design/icons'
import { Grid, Row, Col } from 'react-flexbox-grid'
import { RESERVE_STATE } from './../../constants/reserve'
import LoadingPage from './../../components/LoadingPage'
import { db, storage, cloudFunctions } from './../../config/Fire'
import * as Constants from './../../constants/nodes_database'
import imageReservando from './../../images/ic_launcher.png'
import android_icon from './../../images/android.png'
import apple_icon from './../../images/ios.png'
import './styles.css'

import email_color from './../../images/reservationInfo/email_color.svg'
import email_grey from './../../images/reservationInfo/email_grey.svg'
import email_unselected from './../../images/reservationInfo/email_unselected.svg'
import loading_color from './../../images/reservationInfo/loading_color.svg'
import loading_grey from './../../images/reservationInfo/loading_grey.svg'
import loading_unselected from './../../images/reservationInfo/loading_unselected.svg'
import profile_color from './../../images/reservationInfo/profile_color.svg'
import profile_grey from './../../images/reservationInfo/profile_grey.svg'
import profile_unselected from './../../images/reservationInfo/profile_unselected.svg'
import success_color from './../../images/reservationInfo/success_color.svg'
import success_grey from './../../images/reservationInfo/success_grey.svg'
import success_unselected from './../../images/reservationInfo/success_unselected.svg'

const { Step } = Steps

const stepsNames = {
    email: 'Email',
    data: 'Datos personales',
    joining: 'Sumándote a la reserva',
    ready: '¡Listo!',
    error: 'Error'
}

const ERROR_USER_JOIN_TYPES = {
    PLACES_OCCUPIED: 'PLACES_OCCUPIED',
    ALREADY_JOINED: 'ALREADY_JOINED',
    TIME_MIN_LAPSE: 'TIME_MIN_LAPSE',
    TIME_MAX_LAPSE: 'TIME_MAX_LAPSE',
    UNKNOW_ERROR: 'UNKNOW_ERROR'
}

const ReservationsInformation = props => {
    const [reservation, setReservation] = useState(null)
    const [restaurant, setRestaurant] = useState(null)
    const [reservationError, setReservationError] = useState(false)
    const [fileListProfile, setFileListProfile] = useState([])
    const [userJoinVisible, setUserJoinVisible] = useState(false)
    //For steps
    const [stepsState, setStepsState] = useState({ step: 1, loading: false, user: null, error: false, errorType: '' })
    const [form] = Form.useForm()

    useEffect(() => {
        const { location } = props
        var paths = location.pathname.split('/')
        if (paths.length === 3 && paths[1] === 'reservations' && paths[2] !== '') {
            db.ref(`${Constants.RESERVATIONS}/${paths[2]}`).once('value')
                .then((snapshot) => {
                    if (snapshot.exists()) {
                        const reservation = snapshot.val()
                        db.ref(`${Constants.RESTAURANTS}/${reservation.restoId}`).once('value')
                            .then((restoSnap) => {
                                if (restoSnap.exists()) {
                                    const restaurant = restoSnap.val()
                                    if (restaurant && restaurant.logo && restaurant.logo !== '') {
                                        var imagesProfile = []
                                        storage.ref().child(restaurant.logo).getDownloadURL()
                                            .then(url => {
                                                imagesProfile.push({ uid: -1, name: '0', status: 'done', url: url })
                                                setReservation(reservation)
                                                setRestaurant(restaurant)
                                                setFileListProfile(imagesProfile)
                                            })
                                            .catch(err => {
                                                console.log(err)
                                                setReservation(reservation)
                                                setRestaurant(restaurant)
                                            })
                                    } else {
                                        setReservation(reservation)
                                        setRestaurant(restaurant)
                                    }
                                } else {
                                    console.log('Error getting documents')
                                    setReservationError(true)
                                }
                            })
                            .catch(err => {
                                console.log(err)
                                setReservationError(true)
                            })
                    } else {
                        console.log('Error getting documents')
                        setReservationError(true)
                    }
                })
                .catch(err => {
                    console.log(err)
                    setReservationError(true)
                })
        } else {
            console.log('Path error: ' + paths)
            setReservationError(true)
        }
    }, [])

    const handleCancelUserJoin = () => {
        form.resetFields()
        setUserJoinVisible(false)
        setStepsState({ step: 1, loading: false, user: null, error: false, errorType: '' })
    }

    const onBackStepTo = step => {
        setStepsState({ step: step, loading: false })
    }

    const handleStepForm1 = values => {
        const email = values.field_email
        setStepsState({
            step: 1,
            loading: true
        })
        return db.ref(`${Constants.USERS}`).orderByChild('email').equalTo(`${email}`).once('value')
            .then((usersSnap) => {
                if (usersSnap.exists()) {
                    var user = null
                    usersSnap.forEach(userSnap => {
                        user = userSnap.val()
                    })
                    setStepsState({
                        step: 2,
                        user: user,
                        loading: false
                    })
                    form.setFieldsValue({
                        field_email2: email,
                        field_first_name: user.firstName,
                        field_last_name: user.lastName,
                        field_dni: user.dni,
                        field_phone: user.phone,
                        field_street: user.street,
                        field_city: user.city ? user.city : (restaurant && restaurant.address && restaurant.address.city) ? restaurant.address.city : undefined,
                        field_province: user.province ? user.province : (restaurant && restaurant.address && restaurant.address.province) ? restaurant.address.province : undefined,
                        field_country: user.country ? user.country : (restaurant && restaurant.address && restaurant.address.country) ? restaurant.address.country : undefined
                    })
                } else {
                    setStepsState({
                        step: 2,
                        user: { email: email },
                        loading: false
                    })
                    form.setFieldsValue({
                        field_email2: email,
                        field_first_name: undefined,
                        field_last_name: undefined,
                        field_dni: undefined,
                        field_phone: undefined,
                        field_street: undefined,
                        field_city: (restaurant && restaurant.address && restaurant.address.city) ? restaurant.address.city : undefined,
                        field_province: (restaurant && restaurant.address && restaurant.address.province) ? restaurant.address.province : undefined,
                        field_country: (restaurant && restaurant.address && restaurant.address.country) ? restaurant.address.country : undefined
                    })
                }
            })
    }

    const handleStepForm2 = values => {
        setStepsState({
            step: 3,
            loading: false,
            user: stepsState.user
        })
        if (reservation && stepsState && stepsState.user) {
            return cloudFunctions.tryJoinReserve({
                reservationId: reservation.reservationId,
                userId: stepsState.user.uid ? stepsState.user.uid : '',
                userEmail: values.field_email2,
                userPhone: values.field_phone,
                userDNI: values.field_dni,
                userFirstName: values.field_first_name,
                userLastName: values.field_last_name,
                userStreet: values.field_street,
                userCity: values.field_city,
                userProvince: values.field_province,
                userCountry: values.field_country
            })
                .then((response) => {
                    if (response.data !== undefined && response.data.code === 0) {
                        setStepsState({
                            step: 4,
                            loading: false,
                            user: stepsState.user,
                            error: false,
                            errorType: ''
                        })
                    } else {
                        console.log('tryJoinReserve: ' + JSON.stringify(response))
                        if (response.data !== undefined) {
                            switch (response.data.message) {
                                case 'places occupied':
                                    setStepsState({
                                        step: 4,
                                        loading: false,
                                        user: stepsState.user,
                                        error: true,
                                        errorType: ERROR_USER_JOIN_TYPES.PLACES_OCCUPIED
                                    })
                                    break
                                case 'user email reservation already joined':
                                    setStepsState({
                                        step: 4,
                                        loading: false,
                                        user: stepsState.user,
                                        error: true,
                                        errorType: ERROR_USER_JOIN_TYPES.ALREADY_JOINED
                                    })
                                    break
                                case 'reservation not available minimumPreviousReservationHours':
                                    setStepsState({
                                        step: 4,
                                        loading: false,
                                        user: stepsState.user,
                                        error: true,
                                        errorType: ERROR_USER_JOIN_TYPES.TIME_MIN_LAPSE
                                    })
                                    break
                                case 'reservation not available maximumPreviousReservationDays':
                                    setStepsState({
                                        step: 4,
                                        loading: false,
                                        user: stepsState.user,
                                        error: true,
                                        errorType: ERROR_USER_JOIN_TYPES.TIME_MAX_LAPSE
                                    })
                                    break
                                default:
                                    message.error('La reserva no es válida. Por favor, vuelva a intentarlo.')
                                    setStepsState({
                                        step: 4,
                                        loading: false,
                                        user: stepsState.user,
                                        error: true,
                                        errorType: ERROR_USER_JOIN_TYPES.UNKNOW_ERROR
                                    })
                                    break
                            }
                        }
                    }
                })
        } else {
            message.error('La reserva no es válida. Por favor, vuelva a intentarlo.')
            setStepsState({
                step: 4,
                loading: false,
                user: stepsState.user,
                error: true,
                errorType: ERROR_USER_JOIN_TYPES.UNKNOW_ERROR
            })
        }
    }

    const renderUserStepsComponent = (stepsState) => {
        switch (stepsState.step) {
            case 1:
                return (
                    <Grid className="stepUserJoinCont">
                        <Row center="xs">
                            <Col xs={3}>
                                <img className="imageStep" src={email_color} alt="email"/>
                                <h4 className="textStep">E-MAIL</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={profile_grey} alt="perfil"/>
                                <h4 className="textStep">TUS DATOS</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={loading_grey} alt="cargando"/>
                                <h4 className="textStep">UNIÉNDOSE</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={success_grey} alt="listo"/>
                                <h4 className="textStep">LISTO!</h4>
                            </Col>
                        </Row>
                        <Form form={form} onFinish={(values) => handleStepForm1(values)}>
                            <Row center="xs">
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_email" rules={[{
                                        type: 'email',
                                        message: 'El correo no es válido'
                                    }, { required: true, message: 'Por favor, ingrese su correo electrónico' }]}>
                                        <Input placeholder="Correo electrónico"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Form.Item>
                                        {
                                            stepsState.loading ?
                                                <Button disabled={true} loading>
                                                    Cancelar
                                                </Button>
                                                :
                                                <Button disabled={false} onClick={() => handleCancelUserJoin()}>
                                                    Cancelar
                                                </Button>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col xs={6}>
                                    <Form.Item>
                                        {
                                            stepsState.loading ?
                                                <Button htmlType="submit" disabled={true} loading>
                                                    Continuar
                                                </Button>
                                                :
                                                <Button className="buttonNextStep" htmlType="submit" disabled={false}>
                                                    Continuar
                                                </Button>
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Grid>
                )
            case 2:
                return (
                    <Grid className="stepUserJoinCont">
                        <Row center="xs">
                            <Col xs={3}>
                                <img className="imageStep" src={email_unselected} alt="email"/>
                                <h4 className="textStep">E-MAIL</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={profile_color} alt="perfil"/>
                                <h4 className="textStep">TUS DATOS</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={loading_grey} alt="cargando"/>
                                <h4 className="textStep">UNIÉNDOSE</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={success_grey} alt="listo"/>
                                <h4 className="textStep">LISTO!</h4>
                            </Col>
                        </Row>
                        <Form form={form} onFinish={(values) => handleStepForm2(values)}>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_first_name" rules={[{
                                        required: true,
                                        message: 'Por favor, ingrese su/s nombre/s'
                                    }]}>
                                        <Input placeholder="Nombre/s"/>
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_last_name" rules={[{
                                        required: true,
                                        message: 'Por favor, ingrese su/s apellido/s'
                                    }]}>
                                        <Input placeholder="Apellido/s"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_dni"
                                               rules={[{ required: true, message: 'Por favor, ingrese su DNI' }]}>
                                        <Input type="number" placeholder="dni"/>
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_email2" rules={[{
                                        type: 'email',
                                        message: 'El correo no es válido'
                                    }, { required: false, message: 'Por favor, ingrese su correo electrónico' }]}>
                                        <Input placeholder="Correo electrónico" disabled/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_phone"
                                               rules={[{ required: true, message: 'Por favor, ingrese su teléfono' }]}>
                                        <Input type="number" placeholder="Teléfono"/>
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_street"
                                               rules={[{ required: true, message: 'Por favor, ingrese su dirección' }]}>
                                        <Input placeholder="Dirección"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6} className="formItemXSBottom">
                                    <Form.Item name="field_city"
                                               rules={[{ required: true, message: 'Por favor, ingrese su ciudad' }]}>
                                        <Input placeholder="Ciudad"/>
                                    </Form.Item>
                                </Col>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_province"
                                               rules={[{ required: true, message: 'Por favor, ingrese su provincia' }]}>
                                        <Input placeholder="Provincia"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={12} sm={6}>
                                    <Form.Item name="field_country"
                                               rules={[{ required: true, message: 'Por favor, ingrese su país' }]}>
                                        <Input placeholder="País"/>
                                    </Form.Item>
                                </Col>
                            </Row>
                            <Row>
                                <Col xs={6}>
                                    <Form.Item>
                                        {
                                            stepsState.loading ?
                                                <Button disabled={true} loading>
                                                    Atrás
                                                </Button>
                                                :
                                                <Button disabled={false} onClick={() => onBackStepTo(1)}>
                                                    Atrás
                                                </Button>
                                        }
                                    </Form.Item>
                                </Col>
                                <Col xs={6}>
                                    <Form.Item>
                                        {
                                            stepsState.loading ?
                                                <Button htmlType="submit" disabled={true} loading>
                                                    Unirse
                                                </Button>
                                                :
                                                <Button className="buttonNextStep" htmlType="submit" disabled={false}>
                                                    Unirse
                                                </Button>
                                        }
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                    </Grid>
                )
            case 3:
                return (
                    <Grid className="stepUserJoinCont">
                        <Row center="xs">
                            <Col xs={3}>
                                <img className="imageStep" src={email_unselected} alt="email"/>
                                <h4 className="textStep">E-MAIL</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                <h4 className="textStep">TUS DATOS</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={loading_color} alt="cargando"/>
                                <h4 className="textStep">UNIÉNDOSE</h4>
                            </Col>
                            <Col xs={3}>
                                <img className="imageStep" src={success_grey} alt="listo"/>
                                <h4 className="textStep">LISTO!</h4>
                            </Col>
                        </Row>
                        <Row center="xs">
                            <Col xs={12} sm={6}>
                                <Result
                                    icon={<LoadingOutlined/>}
                                    title="Estamos comprabando la información para unirte a la reserva"
                                    subTitle="Aguarda un momento por favor."
                                />
                            </Col>
                        </Row>
                    </Grid>
                )
            case 4:
                if (stepsState && stepsState.error === false) {
                    return (
                        <Grid className="stepUserJoinCont">
                            <Row center="xs">
                                <Col xs={3}>
                                    <img className="imageStep" src={email_unselected} alt="email"/>
                                    <h4 className="textStep">E-MAIL</h4>
                                </Col>
                                <Col xs={3}>
                                    <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                    <h4 className="textStep">TUS DATOS</h4>
                                </Col>
                                <Col xs={3}>
                                    <img className="imageStep" src={loading_unselected} alt="cargando"/>
                                    <h4 className="textStep">UNIÉNDOSE</h4>
                                </Col>
                                <Col xs={3}>
                                    <img className="imageStep" src={success_color} alt="listo"/>
                                    <h4 className="textStep">LISTO!</h4>
                                </Col>
                            </Row>
                            <Row center="xs">
                                <Col xs={12} sm={6}>
                                    <Result
                                        status="success"
                                        title="¡Aceptaste la invitación!"
                                        subTitle="Te sumaste exitosamente a la mesa reservada. ¡Te esperamos!"
                                    />
                                </Col>
                            </Row>
                        </Grid>
                    )
                } else {
                    switch (stepsState.errorType) {
                        case ERROR_USER_JOIN_TYPES.PLACES_OCCUPIED:
                            return (
                                <Grid className="stepUserJoinCont">
                                    <Row center="xs">
                                        <Col xs={3}>
                                            <img className="imageStep" src={email_unselected} alt="email"/>
                                            <h4 className="textStep">E-MAIL</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                            <h4 className="textStep">TUS DATOS</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={loading_unselected} alt="cargando"/>
                                            <h4 className="textStep">UNIÉNDOSE</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={success_grey} alt="listo"/>
                                            <h4 className="textStep">ERROR</h4>
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={12} sm={6}>
                                            <Result
                                                status="error"
                                                title="Lo sentimos, todos los lugares de la reserva han sido ocupados."
                                            />
                                        </Col>
                                    </Row>
                                </Grid>
                            )
                        case ERROR_USER_JOIN_TYPES.ALREADY_JOINED:
                            return (
                                <Grid className="stepUserJoinCont">
                                    <Row center="xs">
                                        <Col xs={3}>
                                            <img className="imageStep" src={email_unselected} alt="email"/>
                                            <h4 className="textStep">E-MAIL</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                            <h4 className="textStep">TUS DATOS</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={loading_unselected} alt="cargando"/>
                                            <h4 className="textStep">UNIÉNDOSE</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={success_grey} alt="listo"/>
                                            <h4 className="textStep">ERROR</h4>
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={12} sm={6}>
                                            <Result
                                                status="warning"
                                                title="Ya se encuentra anotado en la reserva."
                                            />
                                        </Col>
                                    </Row>
                                </Grid>
                            )
                        case ERROR_USER_JOIN_TYPES.TIME_MIN_LAPSE:
                            return (
                                <Grid className="stepUserJoinCont">
                                    <Row center="xs">
                                        <Col xs={3}>
                                            <img className="imageStep" src={email_unselected} alt="email"/>
                                            <h4 className="textStep">E-MAIL</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                            <h4 className="textStep">TUS DATOS</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={loading_unselected} alt="cargando"/>
                                            <h4 className="textStep">UNIÉNDOSE</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={success_grey} alt="listo"/>
                                            <h4 className="textStep">ERROR</h4>
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={12} sm={6}>
                                            <Result
                                                status="error"
                                                title="Lo sentimos, el tiempo mínimo previo a la reserva para unirse se ha terminado."
                                            />
                                        </Col>
                                    </Row>
                                </Grid>
                            )
                        case ERROR_USER_JOIN_TYPES.TIME_MAX_LAPSE:
                            return (
                                <Grid className="stepUserJoinCont">
                                    <Row center="xs">
                                        <Col xs={3}>
                                            <img className="imageStep" src={email_unselected} alt="email"/>
                                            <h4 className="textStep">E-MAIL</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                            <h4 className="textStep">TUS DATOS</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={loading_unselected} alt="cargando"/>
                                            <h4 className="textStep">UNIÉNDOSE</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={success_grey} alt="listo"/>
                                            <h4 className="textStep">ERROR</h4>
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={12} sm={6}>
                                            <Result
                                                status="error"
                                                title="Lo sentimos, todavía no se encuentra en el tiempo permitido de unirse a la reserva."
                                            />
                                        </Col>
                                    </Row>
                                </Grid>
                            )
                        default:
                            return (
                                <Grid className="stepUserJoinCont">
                                    <Row center="xs">
                                        <Col xs={3}>
                                            <img className="imageStep" src={email_unselected} alt="email"/>
                                            <h4 className="textStep">E-MAIL</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={profile_unselected} alt="perfil"/>
                                            <h4 className="textStep">TUS DATOS</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={loading_unselected} alt="cargando"/>
                                            <h4 className="textStep">UNIÉNDOSE</h4>
                                        </Col>
                                        <Col xs={3}>
                                            <img className="imageStep" src={success_grey} alt="listo"/>
                                            <h4 className="textStep">ERROR</h4>
                                        </Col>
                                    </Row>
                                    <Row center="xs">
                                        <Col xs={12} sm={6}>
                                            <Result
                                                status="error"
                                                title="Lo sentimos, se produjo un error desconocido. Vuelva a intentarlo."
                                            />
                                        </Col>
                                    </Row>
                                </Grid>
                            )
                    }
                }
        }
    }

    return (
        <div>
            {
                reservationError ?
                    <Result
                        status="404"
                        title="404"
                        subTitle="Lo siento, no se encontro la reserva solicitada."
                    />
                    :
                    (reservation && restaurant) ?
                        <div className="reservationInformationCont">
                            <Grid className="gridCont">
                                <Row center="md">
                                    <Col xs={12} sm={12} md={10} lg={8}>
                                        <Card
                                            style={{ borderRadius: '6px', paddingBottom: '0' }}
                                            headStyle={{
                                                backgroundColor: 'rgb(242, 242, 242)',
                                                border: 0,
                                                borderRadius: '6px 6px 0 0'
                                            }}
                                            bodyStyle={{ borderRadius: '0 0 6px 6px', paddingBottom: '0' }}
                                            title={
                                                <div className="titleCardCont">
                                                    <Avatar size={80}
                                                            src={fileListProfile.length > 0 ? fileListProfile[0].url : imageReservando}/><br/>
                                                    <h2>{restaurant.name}</h2>
                                                </div>
                                            }>
                                            <Grid>
                                                <Row center="xs">
                                                    <Col xs={12}>
                                                        <h2 className="nameUserCont">{reservation.user.userName}</h2>
                                                    </Col>
                                                </Row>
                                                <Row center="xs">
                                                    <Col xs={12}>
                                                        <h3 className="bodyCont">Realizó una reserva en <span
                                                            className="restaurantNameSpan">{restaurant.name}</span> y te
                                                            invita a compartir mesa el día <span
                                                                className="purpleText">{reservation.date}</span> a
                                                            las <span className="purpleText">{reservation.hour}</span>
                                                        </h3>
                                                    </Col>
                                                </Row>
                                                {
                                                    reservation.state === RESERVE_STATE.accepted &&
                                                    <Row center="xs">
                                                        <Col xs={12}>
                                                            <h2 className="titleInvite">¿Aceptas la invitación?</h2>
                                                        </Col>
                                                        <Divider/>
                                                        {
                                                            userJoinVisible ?
                                                                <Col xs={12}>
                                                                    {renderUserStepsComponent(stepsState)}
                                                                </Col>
                                                                :
                                                                <Col xs={12}>
                                                                    <Button className="buttonInvite" size="large"
                                                                            onClick={() => {
                                                                                setUserJoinVisible(true)
                                                                            }}>Sí, voy!</Button>
                                                                </Col>
                                                        }
                                                    </Row>
                                                }
                                                <Row>
                                                    <Col xs={5}>
                                                        <Row end="xs">
                                                            <Col xs={12}>
                                                                <a href="https://play.google.com/store/apps/details?id=com.reservando.android"
                                                                   target="_blank" rel="noopener noreferrer"><Avatar
                                                                    size="large" src={android_icon}></Avatar></a>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={2}></Col>
                                                    <Col xs={5}>
                                                        <Row start="xs">
                                                            <Col xs={12}>
                                                                <a href="https://apps.apple.com/us/app/reservando/id1454333767?l=es&ls=1"
                                                                   target="_blank" rel="noopener noreferrer"><Avatar
                                                                    size="large" src={apple_icon}></Avatar></a>
                                                            </Col>
                                                        </Row>
                                                    </Col>
                                                </Row>
                                            </Grid>
                                        </Card>
                                    </Col>
                                </Row>
                            </Grid>
                        </div>
                        :
                        <LoadingPage/>
            }
        </div>
    )
}

export default withRouter(ReservationsInformation)